import { create } from "zustand";
import { persist } from "zustand/middleware";
import STATE_NAMES from "../state-names";

export type AvailableLanguages = "english" | "korean";

type Store = {
  language: AvailableLanguages;
  setLanguage: (language: AvailableLanguages) => void;
};

const useLanguageStore = create<Store>()(
  persist(
    (set) => ({
      language: "english",
      setLanguage: (language) => set({ language })
    }),
    {
      name: STATE_NAMES.language
    }
  )
);

export default useLanguageStore;
